function initProductTecnologies() {
  // Aguarda o Swiper estar disponível
  if (typeof Swiper === 'undefined') {
    setTimeout(initProductTecnologies, 100);
    return;
  }

  const elements = document.querySelectorAll('[data-product-tecnologies]');

  elements.forEach((element, index) => {
    if (element.dataset.tecInitialized) {
      return; 
    }

    try {
      new Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        },
      });

      element.dataset.tecInitialized = 'true';
    } catch (error) {
      console.error('Tecnologias: Error initializing Swiper:', error);
    }
  });
}

// Inicializa no carregamento do DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initProductTecnologies();
  });
} else {
  initProductTecnologies();
}

// Se o tema usar navegação dinâmica
document.addEventListener('shopify:section:load', () => {
  initProductTecnologies();
});
